import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO } from '@/hooks/useSEO';

const services = [
  {
    id: 'iphone',
    icon: 'ri-smartphone-line',
    brand: 'Apple',
    title: 'iPhone 維修',
    heroImage: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svcpage1.jpg',
    desc: '支援 iPhone 6S 至最新 iPhone 16 系列全機型維修，使用原廠規格零件，3個月保固。',
    repairs: [
      { name: '電池更換', price: 'NT$600起', time: '1-2小時' },
      { name: '後鏡頭更換', price: 'NT$600起', time: '1-2小時' },
      { name: 'Face ID 修復', price: 'NT$2,000起', time: '2-3小時' },
      { name: '充電口維修', price: 'NT$600起', time: '1-2小時' },
      { name: '麥克風/喇叭維修', price: 'NT$600起', time: '1小時' },
      { name: '主板維修/進水', price: 'NT$1,500起', time: '1-5工作天' },
    ],
  },
  {
    id: 'ipad',
    icon: 'ri-tablet-line',
    brand: 'Apple',
    title: 'iPad 維修',
    heroImage: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svcpage2.jpg',
    desc: '支援 iPad Pro、iPad Air、iPad Mini 及標準 iPad 全系列維修，原廠規格零件。',
    repairs: [
      { name: '螢幕玻璃更換', price: 'NT$2,000起', time: '2-4小時' },
      { name: '電池更換', price: 'NT$2,000起', time: '1-2小時' },
      { name: '充電口維修', price: 'NT$2,000起', time: '1-2小時' },
      { name: 'Home鍵維修', price: 'NT$1,500起', time: '1小時' },
      { name: 'Face ID 修復', price: 'NT$2,500起', time: '2-3小時' },
      { name: '主板維修', price: 'NT$2,000起', time: '1-3工作天' },
    ],
  },
  {
    id: 'macbook',
    icon: 'ri-macbook-line',
    brand: 'Apple',
    title: 'MacBook 維修',
    heroImage: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svcpage3.jpg',
    desc: '支援 MacBook Air、MacBook Pro 全系列，包括 M1/M2/M3/M4 晶片機型。',
    repairs: [
      { name: '螢幕更換', price: 'NT$6,500起', time: '2-4小時' },
      { name: '鍵盤更換', price: 'NT$4,000起', time: '2-3小時' },
      { name: '主板維修/清洗', price: 'NT$1,500起', time: '1-5工作天' },
      { name: '進水搶救', price: 'NT$1,500起', time: '1-7工作天' },
      { name: 'SSD 更換/升級', price: 'NT$4,500起', time: '當天可好' },
      { name: '充電口維修', price: 'NT$2,500起', time: '2-4小時' },
    ],
  },
  {
    id: 'android',
    icon: 'ri-android-line',
    brand: 'Android',
    title: 'Android 維修',
    heroImage: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svcpage4.jpg',
    desc: '支援 Samsung、ASUS、Google Pixel、Sony 等主流 Android 品牌全機型維修。',
    repairs: [
      { name: '螢幕更換', price: 'NT$1,800起', time: '1-3小時' },
      { name: '電池更換', price: 'NT$800起', time: '1-3小時' },
      { name: '後鏡頭更換', price: 'NT$1,200起', time: '1-2小時' },
      { name: '折疊機螢幕維修', price: 'NT$7,500起', time: '3-4小時' },
      { name: '充電口維修', price: 'NT$800起', time: '1-3小時' },
      { name: '主板維修', price: 'NT$2,000起', time: '1-5工作天' },
    ],
  },
];

export default function ServicesPage() {
  useSEO({
    title: '維修服務項目｜iPhone iPad MacBook Android 全品牌維修',
    description: '兄弟維修提供 iPhone、iPad、MacBook、Samsung、ASUS、Google Pixel 全品牌維修服務。螢幕更換、電池維修、主板維修、進水搶救、資料救援，Apple IRP 認證，3個月保固。',
    keywords: 'iPhone維修服務,iPad維修,MacBook維修,Android維修,手機資料救援,台北手機維修',
    canonical: '/services',
  });

  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <main>
        {/* Page Hero */}
        <section className="pt-32 pb-16 bg-gray-950 relative overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svchero.jpg"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
            <div className="inline-flex items-center gap-2 text-orange-400 text-sm font-medium mb-4">
              <span className="w-8 h-px bg-orange-400" />
              維修服務
              <span className="w-8 h-px bg-orange-400" />
            </div>
            <h1 className="text-5xl font-bold text-white mb-6">全方位裝置維修</h1>
            <p className="text-gray-400 text-lg max-w-xl mx-auto">
              iPhone、iPad、MacBook、Android 全品牌維修。專業技師，原廠零件，快速可靠。
            </p>
          </div>
        </section>

        {/* Services */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 space-y-20">
            {services.map((svc, idx) => (
              <div key={svc.id} className={`grid lg:grid-cols-2 gap-12 items-center ${idx % 2 === 1 ? 'lg:grid-flow-dense' : ''}`}>
                {/* Image */}
                <div className={idx % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <img
                    src={svc.heroImage}
                    alt={svc.title}
                    className="w-full h-72 object-cover object-top rounded-2xl"
                  />
                </div>

                {/* Content */}
                <div className={idx % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                  <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-500 text-xs font-medium px-3 py-1 rounded-full mb-4">
                    <i className={`${svc.icon} text-sm`} />
                    {svc.brand}
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">{svc.title}</h2>
                  <p className="text-gray-500 mb-8 leading-relaxed">{svc.desc}</p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
                    {svc.repairs.map((r) => (
                      <div key={r.name} className="flex items-center justify-between bg-gray-50 rounded-xl px-4 py-3">
                        <div>
                          <div className="text-sm font-medium text-gray-800">{r.name}</div>
                          <div className="text-xs text-gray-400 mt-0.5">{r.time}</div>
                        </div>
                        <div className="text-sm font-bold text-orange-500 whitespace-nowrap ml-2">{r.price}</div>
                      </div>
                    ))}
                  </div>

                  <button
                    onClick={() => navigate('/pricing')}
                    className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer"
                  >
                    查詢精確報價
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Data Recovery CTA */}
        <section className="py-16 bg-gray-950 relative overflow-hidden">
          <div className="absolute inset-0 opacity-30">
            <img
              src="https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/drsvc1.jpg"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-gray-950/80 to-gray-950/60" />

          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
              {/* Left */}
              <div className="flex-1">
                <div className="inline-flex items-center gap-2 bg-orange-500/20 text-orange-400 text-xs font-semibold px-3 py-1.5 rounded-full mb-5">
                  <i className="ri-database-2-line" />
                  特色加值服務
                </div>
                <h2 className="text-4xl font-bold text-white mb-4">
                  手機資料<span className="text-orange-400">救援服務</span>
                </h2>
                <p className="text-gray-300 leading-relaxed mb-6 max-w-lg">
                  手機進水、螢幕破裂、系統崩潰或誤刪重要資料？兄弟維修提供專業晶片級資料救援，<strong className="text-white">救得到才收費</strong>。支援 iPhone、Samsung、ASUS、Google Pixel 等全品牌。
                </p>
                <div className="flex flex-wrap gap-3 mb-8">
                  {[
                    { icon: 'ri-microscope-line', text: '免費初步診斷' },
                    { icon: 'ri-shield-keyhole-line', text: '資料絕對保密' },
                    { icon: 'ri-time-line', text: '最快當天完成' },
                    { icon: 'ri-money-dollar-circle-line', text: '救到才收費' },
                  ].map((f) => (
                    <div key={f.text} className="flex items-center gap-2 bg-white/10 text-white text-sm px-4 py-2 rounded-full">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className={`${f.icon} text-orange-400`} />
                      </div>
                      {f.text}
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => navigate('/services/data-recovery')}
                  className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看資料救援詳情
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </button>
              </div>

              {/* Right - Stats */}
              <div className="grid grid-cols-2 gap-4 flex-shrink-0">
                {[
                  { num: '95%', label: '救援成功率' },
                  { num: '免費', label: '初步診斷' },
                  { num: '當天', label: '最快完成' },
                  { num: '全品牌', label: '支援機型' },
                ].map((s) => (
                  <div key={s.label} className="bg-white/5 border border-white/10 rounded-2xl p-5 text-center w-32">
                    <div className="text-2xl font-bold text-orange-400 mb-1">{s.num}</div>
                    <div className="text-gray-400 text-xs">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Guarantee */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-3">維修服務保障</h2>
              <p className="text-gray-500">每項維修都享有完善的服務保障</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { icon: 'ri-shield-check-line', title: '3個月保固', desc: '維修後相同問題免費重修' },
                { icon: 'ri-eye-line', title: '免費診斷', desc: '帶機到店立即免費檢測' },
                { icon: 'ri-price-tag-3-line', title: '透明報價', desc: '維修前確認費用再施工' },
                { icon: 'ri-tools-line', title: '原廠零件', desc: '使用原廠規格認證零件' },
              ].map((g) => (
                <div key={g.title} className="text-center bg-white rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-50 rounded-xl mx-auto mb-4">
                    <i className={`${g.icon} text-orange-500 text-xl`} />
                  </div>
                  <div className="font-bold text-gray-900 mb-1">{g.title}</div>
                  <div className="text-gray-500 text-sm">{g.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
